import { render, staticRenderFns } from "./coderInpatientDemographics.vue?vue&type=template&id=1c4a51a6&scoped=true&"
import script from "./coderInpatientDemographics.vue?vue&type=script&lang=js&"
export * from "./coderInpatientDemographics.vue?vue&type=script&lang=js&"
import style0 from "./coderInpatientDemographics.vue?vue&type=style&index=0&id=1c4a51a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4a51a6",
  null
  
)

export default component.exports